// The Infinite's mark, drawn in code: an infinity loop made of a waveform, with a playhead dot.
export function Logo({ size = 32 }: { size?: number }) {
  const pts: string[] = [];
  for (let i = 0; i <= 120; i++) {
    const a = (i / 120) * Math.PI * 2;
    const r = 1 + 0.06 * Math.sin(a * 14);
    const x = 32 + 24 * Math.sin(a) * r;
    const y = 20 + 11 * Math.sin(a) * Math.cos(a) * r;
    pts.push(`${x.toFixed(2)},${y.toFixed(2)}`);
  }
  return (
    <svg width={size * 1.6} height={size} viewBox="0 0 64 40" aria-hidden="true" focusable="false">
      <defs>
        <linearGradient id="eb-logo-g" x1="0" x2="1">
          <stop offset="0" stopColor="#e69f00" />
          <stop offset="0.5" stopColor="#cc79a7" />
          <stop offset="1" stopColor="#56b4e9" />
        </linearGradient>
      </defs>
      <polyline
        points={pts.join(" ")}
        fill="none"
        stroke="url(#eb-logo-g)"
        strokeWidth="4"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
      <circle cx="32" cy="20" r="3.4" fill="#f0e442" />
    </svg>
  );
}
